import { LaunchDarklyFlagKey, LaunchDarklyFlagSet } from '~/features/provider/Launchdarkly'
// eslint-disable-next-line no-restricted-imports -- launchdarkly-react-client-sdkをimportするため
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { pagesPath } from '~/lib/$path'

export const useFeatureToggle = (key: LaunchDarklyFlagKey) => {
  const flags = useFlags<LaunchDarklyFlagSet>()
  const flag = flags[key] as boolean | undefined

  return {
    // flagがundefinedの場合はloading中とみなす
    flagLoading: flag === undefined,
    flag,
  }
}

export const useFeatureToggleWithRedirect = (
  key: LaunchDarklyFlagKey,
  options: {
    invertFlag?: boolean
    redirectPath?: string
  } = {},
) => {
  const { flag, flagLoading } = useFeatureToggle(key)
  const router = useRouter()
  const { invertFlag = false, redirectPath = pagesPath.$404.$url() } = options

  useEffect(() => {
    if (flagLoading) return
    const shouldRedirect = invertFlag ? flag : !flag
    if (shouldRedirect) router.replace(redirectPath)
  }, [router, flag, flagLoading, invertFlag, redirectPath])

  return { flag, flagLoading }
}
